import { render, staticRenderFns } from "./ManageQuestion.vue?vue&type=template&id=ee760c36"
import script from "./ManageQuestion.vue?vue&type=script&lang=js"
export * from "./ManageQuestion.vue?vue&type=script&lang=js"
import style0 from "./ManageQuestion.vue?vue&type=style&index=0&id=ee760c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports